import React, { useEffect, useState } from 'react';
import { useCarNameLabel } from '../../../../utils/carNames';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useParams } from 'react-router-dom';
import {
  fetCarSaleListing,
  saveAItem,
  removeSavedItem,
  getSavedItems,
} from '../../../../Redux/Actions/UserAction';
import Swal from 'sweetalert2';
import { useTranslation } from 'react-i18next';
import { shareItem } from './../../../../utils/shareItem';
import { buildSavedIdSet, findSavedItemId } from '../../../../utils/savedItems';

export default function CarForSaleCars() {
  const dispatch = useDispatch();
  const params = useParams();
  const { carBrand } = params;

  const { i18n } = useTranslation();
  const isRTL = (i18n.language || 'en').toLowerCase().startsWith('ar');
  /* [CF 2026-08-17 #11.1] The model is free text with no Arabic on the
     row; look it up from the model master. See utils/carNames.js */
  const nameLabel = useCarNameLabel(isRTL);
  // English in English mode, Arabic in Arabic mode (fallback to whichever exists).
  const L = (en, ar) => (isRTL ? ar || en : en || ar);

  useEffect(() => {
    dispatch(fetCarSaleListing());
    dispatch(getSavedItems());
  }, [dispatch]);

  const cars = useSelector((state) => state.home.carSaleList);
  const carsList = cars?.data?.response?.data;
  const savedItemsList = useSelector((state) => state?.home?.savedItemsList);

  // Saved set from the API + per-card optimistic overrides so the heart flips
  // colour instantly on click without waiting for the network / a reload.
  const savedIdSet = buildSavedIdSet(savedItemsList);
  const [savedOverride, setSavedOverride] = useState({});
  const isSaved = (id) =>
    savedOverride[id] !== undefined ? savedOverride[id] : savedIdSet.has(String(id));

  const filteredList = carsList?.filter((car) => car.carBrandId === carBrand);

  console.log('carBrandcarBrand', filteredList);

  const onHandleSave = (carSaleId) => {
    // Check if user is logged in
    const isLoggedIn = sessionStorage.getItem('loged_In') === 'true';

    if (!isLoggedIn) {
      Swal.fire({
        title: 'Please Login to Save',
        text: 'You need to be logged in to save this car. Please login first.',
        icon: 'warning',
        imageUrl: './assets/images/favicon/android-chrome-192x192.png',
        imageHeight: 100,
        confirmButtonColor: '#3ab1f7',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Login',
        showCancelButton: true,
        cancelButtonText: 'Cancel'
      }).then((result) => {
        if (result.isConfirmed) {
          // Redirect to login page
          window.location.href = '#/login';
        }
      });
      return;
    }

    const currentlySaved = isSaved(carSaleId);
    // Optimistic toggle — flip the colour immediately.
    setSavedOverride((prev) => ({ ...prev, [carSaleId]: !currentlySaved }));

    if (currentlySaved) {
      const savedItemId = findSavedItemId(savedItemsList, carSaleId);
      if (savedItemId) dispatch(removeSavedItem({ savedItemId }));
    } else {
      dispatch(saveAItem({ carSaleId }));
    }
  };

  return (
    <div>
      <div class="main-content-area">
        <div class="container">
          <h2 class="mb-2">Cars for Sale</h2>
          <div class="row">
            {filteredList?.map((car) => {
              const logo = car?.businessMedia?.find(
                (media) =>
                  media?.mediaType === 'LOGO' ||
                  media?.mediaType === 'CAR-IMAGES' ||
                  media?.mediaType === 'CAR_IMAGE' ||
                  media?.mediaType === 'IMAGES'
              )?.media?.path;

              return (
                <>
                  <div class="col-6 col-sm-6 col-md-4 col-lg-3 mb-4">
                    <div class="user-cfs-wrap">
                      <div class="line-a">
                        <Link
                          to={`/user-cars-for-sale-detail/${car.carSaleId}`}
                        >
                          <img
                            style={{ width: '100%', height: '10rem' }}
                            src={
                              logo ||
                              'assets/images/service-provider/car-sale/car.jpg'
                            }
                            alt=""
                            class="img-fluid"
                            onError={(e) => {
                              e.target.onerror = null;
                              e.target.src =
                                'assets/images/service-provider/car-sale/car.jpg';
                            }}
                          />
                        </Link>
                      </div>
                      <div class="line-b">
                        {/* Brand + Save/Share — one aligned row */}
                        <div className="cav-card-row">
                          <div class="line-ba">
                            {L(car?.brand?.name, car?.brand?.nameAr)}
                          </div>
                          <div className="cav-card-actions">
                            <button
                              onClick={() => onHandleSave(car?.carSaleId)}
                              title="Save"
                              class="ss-btn"
                              style={{ cursor: 'pointer', background: 'none', border: 'none', color: isSaved(car?.carSaleId) ? '#FFC400' : 'inherit', padding: 0, fontSize: 'inherit' }}
                            >
                              <i class={isSaved(car?.carSaleId) ? 'fas fa-heart' : 'far fa-heart'}></i>
                            </button>
                            <a
                              href="#"
                              onClick={(e) =>
                                shareItem(e, `/user-cars-for-sale-detail/${car.carSaleId}`, car?.carName)
                              }
                              title="Share"
                              class="ss-btn"
                            >
                              <i class="far fa-share-square"></i>
                            </a>
                          </div>
                        </div>
                        {/* Model + year — aligned to the same two columns */}
                        <div className="cav-card-row line-bb">
                          <span>{nameLabel(car?.carModel)}</span>
                          <span>{car?.modelYear?.modelYear}</span>
                        </div>
                      </div>
                      <div class="line-c">
                        <div className="cav-card-row">
                          <span>{car?.kilometerDriven} KM</span>
                          <span>KD {car?.price}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
}
